// 🔧 volunteer_step.js
// ✅ Purpose: Pipeline step for the LGV Volunteer Engine
// ✅ Features:
// - Executes the Volunteer Engine as part of the Core Package
// - Integrates with the shared DemoContext
// - Returns standardized pipeline results
// - Wraps Volunteer Engine report output in the shared Core pipeline result contract
// - Keeps pipeline orchestration independent of engine implementation
// - Fully block-commented for clarity and future devs

import { runVolunteerEngine } from "../../engines/volunteers";
import { createPipelineStepSuccess } from "../pipeline_step";

// =====================================================
// Create Volunteer Pipeline Step
// =====================================================

export const createVolunteerStep = () => ({
  id: "volunteer_builder",

  name: "Volunteer Builder",

  label: "Volunteer Builder",

  // ===================================================
  // Execute the Volunteer Engine
  // ===================================================
  run: async (demoContext) => {
    console.log("🙋 Volunteer Pipeline Step started.");

    const result = await runVolunteerEngine({
      demoContext,
    });

    console.log("✅ Volunteer Pipeline Step completed.", {
      result,
    });

    // ===================================================
    // ✅ Normalize Volunteer into the Core pipeline contract.
    // ===================================================
    // The Volunteer Engine returns its own detailed report shape.
    // The pipeline wrapper adds the standard step/label/message/
    // elapsed metadata used by Demo Report and DemoBuilder.
    // ===================================================

    return createPipelineStepSuccess({
      step: "volunteer_builder",

      label: "Volunteer Builder",

      created: result?.created || 0,

      message: result?.summary || "",

      metadata: result,

      startedAt: demoContext.startedAt,
    });
  },
});